/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Andor application API
 * OpenAPI spec version: v1
 */
import {
  HttpClient
} from '@angular/common/http';
import type {
  HttpContext,
  HttpEvent,
  HttpParams
} from '@angular/common/http';

import {
  Injectable,
  inject
} from '@angular/core';

import type {
  Observable
} from 'rxjs';

import type {
  ApiError,
  DeleteRoleBody,
  DeleteRoleParams,
  GetRolePrivilege200,
  GetRolesParams,
  RoleNoPassword,
  RolesNoPassword,
  SetRoleBody,
  SetRoleParams,
  SetRoleWithoutIdBody,
  SetRoleWithoutIdParams
} from '../models';

import type {
  HttpHeaders,
  HttpResponse as AngularHttpResponse
} from '@angular/common/http';

import {
  ANDOR_BASE_URL
} from '../api.base-url';



interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?:
        | HttpParams
      | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value
        .filter(
          (item) =>
            item != null &&
            (typeof item === 'string' ||
              typeof item === 'number' ||
              typeof item === 'boolean' ||
              (item instanceof Date && !Number.isNaN(item.getTime()))),
        )
        .map((item) =>
          item instanceof Date ? item.toISOString() : item,
        ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (value instanceof Date && !Number.isNaN(value.getTime())) {
      // useDates produces Date query params; serialize to ISO so they reach
      // the wire instead of being dropped by the primitive check below. See #3856.
      filteredParams[key] = value.toISOString();
    } else if (
      value != null &&
      (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}





@Injectable({ providedIn: 'root' })
export class RolesService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(ANDOR_BASE_URL);
 deleteRole<TData = RoleNoPassword>(roleId: string,
    deleteRoleBody: DeleteRoleBody,
    params?: DeleteRoleParams, options?: HttpClientBodyOptions): Observable<TData>;
 deleteRole<TData = RoleNoPassword>(roleId: string,
    deleteRoleBody: DeleteRoleBody,
    params?: DeleteRoleParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 deleteRole<TData = RoleNoPassword>(roleId: string,
    deleteRoleBody: DeleteRoleBody,
    params?: DeleteRoleParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  deleteRole<TData = RoleNoPassword>(
    roleId: string,
    deleteRoleBody: DeleteRoleBody,
    params?: DeleteRoleParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/roles/${encodeURIComponent(String(roleId))}/delete`,
      deleteRoleBody,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/roles/${encodeURIComponent(String(roleId))}/delete`,
      deleteRoleBody,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/roles/${encodeURIComponent(String(roleId))}/delete`,
      deleteRoleBody,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
 getRolePrivilege<TData = GetRolePrivilege200>(roleId: string,
    privilegeName: string, options?: HttpClientBodyOptions): Observable<TData>;
 getRolePrivilege<TData = GetRolePrivilege200>(roleId: string,
    privilegeName: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getRolePrivilege<TData = GetRolePrivilege200>(roleId: string,
    privilegeName: string, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getRolePrivilege<TData = GetRolePrivilege200>(
    roleId: string,
    privilegeName: string, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${this.baseUrl}/v1/roles/${encodeURIComponent(String(roleId))}/privileges/${encodeURIComponent(String(privilegeName))}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      }
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${this.baseUrl}/v1/roles/${encodeURIComponent(String(roleId))}/privileges/${encodeURIComponent(String(privilegeName))}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      }
    );
    }

    return this.http.get<TData>(
      `${this.baseUrl}/v1/roles/${encodeURIComponent(String(roleId))}/privileges/${encodeURIComponent(String(privilegeName))}`,{
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
      }
    );
  }
 getRoles<TData = RolesNoPassword>(params?: GetRolesParams, options?: HttpClientBodyOptions): Observable<TData>;
 getRoles<TData = RolesNoPassword>(params?: GetRolesParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 getRoles<TData = RolesNoPassword>(params?: GetRolesParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  getRoles<TData = RolesNoPassword>(
    params?: GetRolesParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(
      `${this.baseUrl}/v1/roles`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(
      `${this.baseUrl}/v1/roles`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.get<TData>(
      `${this.baseUrl}/v1/roles`,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
 setRoleWithoutId<TData = ApiError>(setRoleWithoutIdBody: SetRoleWithoutIdBody,
    params?: SetRoleWithoutIdParams, options?: HttpClientBodyOptions): Observable<TData>;
 setRoleWithoutId<TData = ApiError>(setRoleWithoutIdBody: SetRoleWithoutIdBody,
    params?: SetRoleWithoutIdParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 setRoleWithoutId<TData = ApiError>(setRoleWithoutIdBody: SetRoleWithoutIdBody,
    params?: SetRoleWithoutIdParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  setRoleWithoutId<TData = ApiError>(
    setRoleWithoutIdBody: SetRoleWithoutIdBody,
    params?: SetRoleWithoutIdParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/roles`,
      setRoleWithoutIdBody,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/roles`,
      setRoleWithoutIdBody,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/roles`,
      setRoleWithoutIdBody,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
 setRole<TData = RoleNoPassword>(roleId: string,
    setRoleBody: SetRoleBody,
    params?: SetRoleParams, options?: HttpClientBodyOptions): Observable<TData>;
 setRole<TData = RoleNoPassword>(roleId: string,
    setRoleBody: SetRoleBody,
    params?: SetRoleParams, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
 setRole<TData = RoleNoPassword>(roleId: string,
    setRoleBody: SetRoleBody,
    params?: SetRoleParams, options?: HttpClientResponseOptions): Observable<AngularHttpResponse<TData>>;
  setRole<TData = RoleNoPassword>(
    roleId: string,
    setRoleBody: SetRoleBody,
    params?: SetRoleParams, options?: HttpClientObserveOptions): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/roles/${encodeURIComponent(String(roleId))}`,
      setRoleBody,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,}
    );
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(
      `${this.baseUrl}/v1/roles/${encodeURIComponent(String(roleId))}`,
      setRoleBody,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,}
    );
    }

    return this.http.post<TData>(
      `${this.baseUrl}/v1/roles/${encodeURIComponent(String(roleId))}`,
      setRoleBody,{
    ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'body',
        params: filteredParams,}
    );
  }
};
